import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { merge } from 'ramda';
import colors from './colors';

const customTheme = {
  palette: { primary1Color: colors.blue }
};

const customBaseTheme = merge(lightBaseTheme, customTheme);

export default customBaseTheme;



// WEBPACK FOOTER //
// ./src/themes/customBaseTheme.js